import useConnectedWeb3Account from '@store/web3Store/hooks/useConnectedWeb3Account';
import { web3AccountsAtom } from '@store/web3Store/web3Store.atoms';
import { EWalletType } from '@store/web3Store/web3Store.enums';
import { useAtom } from 'jotai';
import { useEffect } from 'react';
import useAddress from 'src/store/web3Store/hooks/useAddress';
import useChainId from 'src/store/web3Store/hooks/useChainId';
import useIsWalletConnected from 'src/store/web3Store/hooks/useIsWalletConnected';
import useProvider from 'src/store/web3Store/hooks/useProvider';

const StoreDebug = () => {
	const [address] = useAddress(EWalletType.ethereum);
	const [isWalletConnected] = useIsWalletConnected(EWalletType.ethereum);
	const [chainId] = useChainId(EWalletType.ethereum);
	const [provider] = useProvider(EWalletType.ethereum);
	const [web3Account] = useConnectedWeb3Account(EWalletType.ethereum);
	const [web3Accounts] = useAtom(web3AccountsAtom);

	useEffect(() => {
		console.debug('provider', provider);
	}, [provider]);

	useEffect(() => {
		console.debug('address', address?.toString());
	}, [address]);

	useEffect(() => {
		console.debug('isWalletConnected', isWalletConnected);
	}, [isWalletConnected]);

	useEffect(() => {
		console.debug('wallet id', web3Account?.id);
	}, [web3Account?.id]);

	useEffect(() => {
		console.debug('web3Accounts', web3Accounts);
	}, [web3Accounts]);

	useEffect(() => {
		console.debug('chainId', chainId);
	}, [chainId]);

	return null;
};

export { StoreDebug };
